import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconBook = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.3125 0H1V15H11.3125C12.3438 15 13.1875 14.1562 13.1875 13.125V1.875C13.1875 0.84375 12.3438 0 11.3125 0ZM10.375 6.5625H3.8125V2.8125H10.375V6.5625Z",
		fill: "currentColor"
	})
});
export default SvgIconBook;
